import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem("adminToken", response.data.token);
      toast.success("Login successful!");
      navigate("/admin");
    } catch (error) {
      toast.error("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary/30 flex items-center justify-center px-6" data-testid="admin-login-page">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="text-center mb-4">
            <span className="text-3xl font-heading font-bold text-primary">MURRAY</span>
            <span className="text-3xl font-heading font-light text-accent ml-2">REALTOR</span>
          </div>
          <CardTitle className="text-center text-2xl">Admin Login</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-sm uppercase tracking-widest font-semibold mb-2 block">
                Username
              </Label>
              <Input
                id="username"
                type="text"
                required
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                className="h-12 rounded-none border-border"
                data-testid="username-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm uppercase tracking-widest font-semibold mb-2 block">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                required
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="h-12 rounded-none border-border"
                data-testid="password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 h-12 rounded-none uppercase tracking-widest text-sm font-semibold"
              data-testid="login-button"
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </form>

          <div className="mt-6 p-4 bg-secondary/50 rounded text-sm text-muted-foreground">
            <p className="font-semibold mb-2">Default Credentials:</p>
            <p>Username: <span className="font-mono">paul</span></p>
            <p>Password: <span className="font-mono">murray2026</span></p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;